import responseiveItem from './responsive';

const swatchList = (selector, breakpointMap) => {
  const lists = document.querySelectorAll(selector);
  const map = breakpointMap;

  let current = null;

  const onNewBreakpoint = (breakpoint) => {
    if (breakpoint === current) {
      return;
    }

    current = breakpoint;

    lists.forEach((list) => {
      const total = parseInt(list.getAttribute('data-total'), 10);

      let toShow = map[breakpoint.name];
      if (toShow >= list.children.length) {
        const len = list.children.length - 1;
        toShow = len > 0 ? len : 0;
      }

      for (let i = 0; i < list.children.length; i++) { /* eslint-disable-line no-plusplus */
        const li = list.children[i];
        if (i < toShow) {
          li.style.display = 'inline-block';
        } else {
          li.style.display = 'none';
        }
      }

      const remainder = total - toShow;
      const plusMore = list.lastElementChild;
      if (remainder > 0) {
        plusMore.querySelector('.total-swatch-count').innerText = `+${remainder}`;
        plusMore.style.display = 'block';
      } else {
        plusMore.style.display = 'none';
      }
    });
  };

  responseiveItem(onNewBreakpoint);
};

export default swatchList;
